import React from "react";
import LandingHome from "../section/LandingHome";
import AboutSection from "../section/AboutSection";
import ProductsSection from "../section/ProductsSection";
import SuppliersSection from "../section/SuppliersSection";
import NewsSection from "../section/NewsSection";
import StatiticsSection from "../section/StatiticsSection";
import TeamSection from "../section/TeamSection";
import ContactSection from "../section/ContactSection";
import Mask from "../section/Mask";
export default function Home() {
    return (
        <>
            <LandingHome />
            <AboutSection />
             <ProductsSection />
            <SuppliersSection />
            <NewsSection />
            <Mask/>
            <StatiticsSection />
            <TeamSection />
            <ContactSection /> 
        </>
    );
}